import api from "@/configs/axios-config";

export type PAPart = {
  pa_part_id: number;
  pa_supplier_id: number;
  supplier_code: string | null;
  part_no: string;
  part_name: string;
  ac: number | null;
  routing: number | null;
  production_proposed: number;
  service_proposed: number;
  tooling_proposed: number;
  reason: string | null;
  part_effective_date: string | null;
  pa_no: string | null;
  confirmation_no: string | null;
  result: string | null;
  note: string | null;
  create_date: string | null;
  update_date: string | null;
};

export type PAPartResponse = {
  data: PAPart[];
  total: number;
};

export type PASupplier = {
  pa_supplier_id: number;
  supplier_code: string;
  buyer_code: string | null;
  result: string | null;
  note: string | null;
  create_date: string | null;
  update_date: string | null;
  is_admin_reason: boolean | null;
};

export type PASupplierResponse = {
  data: PASupplier[];
  total: number;
};

export type PAPartRequestParam = {
  search_filter?: string; // part no, part name, pa part id, ac, rt
  supplier_filter?: string; // supplier id, supplier code
  result?: "Wait" | "success";
  reason_id?: number;
  create_date_from?: string; // ISO date string
  create_date_to?: string; // ISO date string
  skip?: number;
  limit?: number;
};

export type PAPartExportParam = Omit<PAPartRequestParam, "skip" | "limit">;

export type PASupplierRequestParam = {
  search_filter?: string; // supplier code, pa supplier id
  buyer_code?: string;
  result?: "Wait" | "success";
  needs_buyer_code_selection?: boolean;
  skip?: number;
  limit?: number;
};

export const getPAPart = async (
  params: PAPartRequestParam,
): Promise<PAPartResponse> => {
  const response = await api.get("/pa-rfq/parts", { params });
  return response.data;
};

export const getPAPartExport = async (
  params: PAPartExportParam,
): Promise<PAPartResponse> => {
  const response = await api.get("/pa-rfq/parts", { params });
  return response.data;
};

export const getPASupplier = async (
  params: PASupplierRequestParam,
): Promise<PASupplierResponse> => {
  const response = await api.get("/pa-rfq/suppliers", { params });
  return response.data;
};

export const updatePASupplierBuyerCode = async (
  pa_supplier_id: number,
  buyer_code: string,
): Promise<PASupplier> => {
  const response = await api.patch(
    `/pa-rfq/suppliers/${pa_supplier_id}/buyer-code`,
    { buyer_code },
  );
  return response.data;
};
